import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { colors, font, maxWidth } from "../styles/theme";
import { faq } from "../data/faq";
import { useRequestModal } from "../components/ModalProvider";

// Блок FAQ — частые вопросы (аккордеон).
export default function FaqSection() {
  const [open, setOpen] = useState(null);
  const { openRequest } = useRequestModal();

  return (
    <section id="faq" className="section-pad" style={{ background: "#fff", padding: "72px 22px", borderTop: "1px solid #eee" }}>
      <div
        style={{
          maxWidth,
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          gap: 48,
          alignItems: "flex-start",
        }}
      >
        {/* Левая колонка — заголовок + CTA */}
        <div className="faq-aside" style={{ flex: "1 1 320px", minWidth: "min(100%,300px)", position: "sticky", top: 100 }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              fontFamily: font.display,
              fontWeight: 600,
              fontSize: 12,
              letterSpacing: ".16em",
              textTransform: "uppercase",
              color: colors.red,
            }}
          >
            <span style={{ width: 26, height: 2, background: colors.red, display: "inline-block" }} />
            Вопросы и ответы
          </span>
          <h2
            style={{
              fontFamily: font.display,
              fontWeight: 700,
              fontSize: "clamp(2rem,4vw,3.2rem)",
              lineHeight: 1.05,
              textTransform: "uppercase",
              margin: "14px 0 0",
              color: colors.ink,
            }}
          >
            Частые вопросы
          </h2>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: colors.text, margin: "18px 0 0", maxWidth: 360 }}>
            Собрали ответы на вопросы, которые чаще всего задают наши клиенты. Не нашли свой — задайте его напрямую.
          </p>
          <button
            onClick={openRequest}
            style={{
              marginTop: 26,
              background: colors.ink,
              color: "#fff",
              border: "none",
              fontFamily: font.display,
              fontWeight: 600,
              fontSize: 15,
              letterSpacing: ".04em",
              textTransform: "uppercase",
              padding: "15px 30px",
              borderRadius: 10,
              cursor: "pointer",
              transition: "background .18s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = colors.red)}
            onMouseLeave={(e) => (e.currentTarget.style.background = colors.ink)}
          >
            Задать вопрос
          </button>
        </div>

        {/* Правая колонка — аккордеон */}
        <div style={{ flex: "1 1 520px", minWidth: "min(100%,320px)", display: "flex", flexDirection: "column", gap: 12 }}>
          {faq.map((item, i) => (
            <FaqRow key={i} item={item} open={open === i} onToggle={() => setOpen(open === i ? null : i)} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqRow({ item, open, onToggle }) {
  return (
    <div
      style={{
        border: `1px solid ${open ? colors.red : "#e6e9ee"}`,
        borderRadius: 14,
        overflow: "hidden",
        background: "#fff",
        transition: "border-color .2s",
      }}
    >
      <button
        onClick={onToggle}
        aria-expanded={open}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 16,
          padding: "20px 22px",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        <span
          style={{
            flex: 1,
            fontFamily: font.display,
            fontWeight: 600,
            fontSize: "clamp(15px,1.8vw,18px)",
            textTransform: "uppercase",
            color: colors.ink,
            lineHeight: 1.25,
          }}
        >
          {item.q}
        </span>
        <span
          style={{
            flex: "none",
            width: 34,
            height: 34,
            borderRadius: 9,
            background: open ? colors.red : colors.redSoft,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background .2s",
          }}
        >
          {open ? <Minus size={18} color="#fff" /> : <Plus size={18} color={colors.red} />}
        </span>
      </button>

      <div style={{ display: "grid", gridTemplateRows: open ? "1fr" : "0fr", transition: "grid-template-rows .28s ease" }}>
        <div style={{ overflow: "hidden" }}>
          <p style={{ margin: 0, padding: "0 22px 22px", fontSize: 15.5, lineHeight: 1.65, color: colors.text }}>
            {item.a}
          </p>
        </div>
      </div>
    </div>
  );
}
